import { Navigate, Route, Routes } from 'react-router-dom'
import ErrorBoundaryComponent from '@/components/ErrorBoundaryComponent/ErrorBoundaryComponent'
import { RolePermissionGuard } from '@/components/RolePermission'
import { DEFAULT_ROUTE } from '@/constant/common'
import ProductLandingPage from './ProductLandingPage/ProductLandingPage'
import AddProductPage from './AddProductPage/AddProductPage'
import ProductDetailPage from './ProductDetailPage/ProductDetailPage'
import { PRODUCT_PERMISSION_MODULE } from './ProductPermission'

export default function TasksRoute() {
  return (
    <ErrorBoundaryComponent>
      <Routes>
        <Route path="" element={<ProductLandingPage />} />
        <Route
          path="add"
          element={
            <RolePermissionGuard
              action="create"
              module={PRODUCT_PERMISSION_MODULE}
              fallback={<Navigate replace to={DEFAULT_ROUTE.PRODUCTS} />}
            >
              <AddProductPage />
            </RolePermissionGuard>
          }
        />
        <Route path=":id/edit" element={<AddProductPage />} />
        <Route path=":id" element={<ProductDetailPage />} />
      </Routes>
    </ErrorBoundaryComponent>
  )
}
